import { Name, formatName } from "@certn/utils";
import { useTranslation } from "react-i18next";

import { Avatar } from "../../avatar/Avatar";
import { AvatarButton } from "../../avatar/AvatarButton";
import {
  DropdownMenu,
  DropdownMenuProps,
} from "../../dropdown-menu/DropdownMenu";

interface ProfileDropDownProps extends DropdownMenuProps {
  name: Name;
  email?: string;
  avatar?: string;
  testID: string;
}

export function ProfileDropdown(props: ProfileDropDownProps) {
  const { t } = useTranslation();
  const { name, email, avatar, testID, ...dropdownMenuProps } = props;

  return (
    <DropdownMenu
      label={name.givenName || "unknown"}
      headerTitle={formatName(name)}
      headerText={email}
      triggerButton={
        <AvatarButton aria-label={t("Avatar")}>
          <Avatar
            name={name}
            image={avatar}
            size="medium"
            testID={`${testID}-avatar`}
          />
        </AvatarButton>
      }
      minWidth="256px"
      {...dropdownMenuProps}
      testID={testID}
    />
  );
}
